export default __webpack_public_path__ + "static/media/tickmark.a284b48c.svg";